
export const TEAM_DATA = [

  // ─────────────────────────────────────────────────────────────
  // CORE TEAM
  // ─────────────────────────────────────────────────────────────
  {
    id: "core-1",
    name: "Achalendra Pratap Singh",
    role: "Coordinator",
    department: "SoCSE",
    roll: "22bcs005",
    email: "22bcs005@smvdu.ac.in",
    category: "Core Team",
    avatar_url: "/assests/Team%20Images/Achalendra%20Pratap%20Singh%2022bcs005.jpg",
    linkedin: null,
  },
  {
    id: "core-2",
    name: "Sachin Tripathi",
    role: "Co-Coordinator",
    department: "SoCSE",
    roll: "23bcs079",
    email: "23bcs079@smvdu.ac.in",
    category: "Core Team",
    avatar_url: "/assests/Team%20Images/Sachin%20Tripathi%2023bcs079.jpeg",
    linkedin: null,
  },
  {
    id: "core-3",
    name: "Yash Srivastava",
    role: "Co-Coordinator",
    department: "SoCSE",
    roll: "23bcs103",
    email: "23bcs103@smvdu.ac.in",
    category: "Core Team",
    avatar_url: "/assests/Team%20Images/Yash%20Srivastava%2023bcs103.jpeg",
    linkedin: null,
  },
  {
    id: "core-4",
    name: "Suraj Rathod",
    role: "Co-Coordinator",
    department: "SoECE",
    roll: "23bec045",
    email: "23bec045@smvdu.ac.in",
    category: "Core Team",
    avatar_url: "/assests/Team%20Images/Rathod%20Suraj%20Makram%2023bec045.jpg",
    linkedin: null,
  },
  {
    id: "core-5",
    name: "Priyanshu Kumar",
    role: "Co-Coordinator",
    department: "SoECE",
    roll: "23bec040",
    email: "23bec040@smvdu.ac.in",
    category: "Core Team",
    avatar_url: null,
    linkedin: null,
  },

  // ─────────────────────────────────────────────────────────────
  // WEBSITE TEAM
  // ─────────────────────────────────────────────────────────────
  {
    id: "web-1",
    name: "Sachin Tripathi",
    role: "Coordinator",
    department: "SoCSE",
    roll: "23bcs079",
    email: "23bcs079@smvdu.ac.in",
    category: "Website Team",
    avatar_url: "/assests/Team%20Images/Sachin%20Tripathi%2023bcs079.jpeg",
    linkedin: null,
  },
  {
    id: "web-2",
    name: "Nitish Kumar Yadav",
    role: "Team Lead",
    department: "SoCSE",
    roll: "24bcs051",
    email: "24bcs051@smvdu.ac.in",
    category: "Website Team",
    avatar_url: "/assests/Team%20Images/Nitish%20Kumar%20Yadav%2024bcs051.jpeg",
    linkedin: null,
  },
  {
    id: "web-3",
    name: "Satish Singh",
    role: "Co-Lead",
    department: "SoCSE",
    roll: "24bcs067",
    email: "24bcs067@smvdu.ac.in",
    category: "Website Team",
    avatar_url: "/assests/Team%20Images/Satish.jpeg",
    linkedin: null,
  },
  {
    id: "web-4",
    name: "Apoorav Sharma",
    role: "Member",
    department: "SoCSE",
    roll: "24bcs014",
    email: "24bcs014@smvdu.ac.in",
    category: "Website Team",
    avatar_url: "/assests/Team%20Images/Apoorav%20Sharma%2024bcs014.jpeg",
    linkedin: null,
  },
  // ─────────────────────────────────────────────────────────────
  // TECHNICAL TEAM
  // ─────────────────────────────────────────────────────────────
  {
    id: "tech-1",
    name: "Sachin Tripathi",
    role: "Coordinator",
    department: "SoCSE",
    roll: "23bcs079",
    email: "23bcs079@smvdu.ac.in",
    category: "Technical Team",
    avatar_url: "/assests/Team%20Images/Sachin%20Tripathi%2023bcs079.jpeg",
    linkedin: null,
  },
  {
    id: "tech-2",
    name: "Shubham Saini",
    role: "Team Lead",
    department: "SoCSE",
    roll: "24bcs074",
    email: "24bcs074@smvdu.ac.in",
    category: "Technical Team",
    avatar_url: "/assests/Team%20Images/Shubham%20Saini%2024bcs074.jpg",
    linkedin: null,
  },
  {
    id: "tech-3",
    name: "Maneesh Kumar",
    role: "Member",
    department: "SoCSE",
    roll: "24bcs041",
    email: "24bcs041@smvdu.ac.in",
    category: "Technical Team",
    avatar_url: "/assests/Team%20Images/Maneesh%20Kumar%2024bcs041.jpg",
    linkedin: null,
  },

  // ─────────────────────────────────────────────────────────────
  // DESIGN TEAM
  // ─────────────────────────────────────────────────────────────
  {
    id: "design-1",
    name: "Yash Srivastava",
    role: "Coordinator",
    department: "SoCSE",
    roll: "23bcs103",
    email: "23bcs103@smvdu.ac.in",
    category: "Design Team",
    avatar_url: "/assests/Team%20Images/Yash%20Srivastava%2023bcs103.jpeg",
    linkedin: null,
  },
  {
    id: "design-2",
    name: "Prayu Suman",
    role: "Team Lead",
    department: "SoBT",
    roll: "23ibo035",
    email: "23ibo035@smvdu.ac.in",
    category: "Design Team",
    avatar_url: "/assests/Team%20Images/Prayu%20Suman%2023ibo035.jpg",
    linkedin: null,
  },
  {
    id: "design-3",
    name: "Naresh Kumar",
    role: "Member",
    department: "SoCSE",
    roll: "24bcs048",
    email: "24bcs048@smvdu.ac.in",
    category: "Design Team",
    avatar_url: "/assests/Team%20Images/Naresh%20Kumar%2024bcs048.jpg",
    linkedin: null,
  },
  {
    id: "design-4",
    name: "Kshitiz Sangral",
    role: "Member",
    department: "SoALD",
    roll: "24bar013",
    email: "24bar013@smvdu.ac.in",
    category: "Design Team",
    avatar_url: "/assests/Team%20Images/KSHITIZ%20SANGRAL%2024bar013.jpg",
    linkedin: null,
  },

  // ─────────────────────────────────────────────────────────────
  // PR TEAM
  // ─────────────────────────────────────────────────────────────
  {
    id: "pr-1",
    name: "Yash Srivastava",
    role: "Coordinator",
    department: "SoCSE",
    roll: "23bcs103",
    email: "23bcs103@smvdu.ac.in",
    category: "PR Team",
    avatar_url: "/assests/Team%20Images/Yash%20Srivastava%2023bcs103.jpeg",
    linkedin: null,
  },
  {
    id: "pr-2",
    name: "Anushka Tickoo",
    role: "Team Lead",
    department: "SoME",
    roll: "23bme006",
    email: "23bme006@smvdu.ac.in",
    category: "PR Team",
    avatar_url:"/assests/Team%20Images/Anushka%20Tickoo%2023bme006.jpeg",
    linkedin: null,
  },
  {
    id: "pr-3",
    name: "Prayu Suman",
    role: "Team Lead",
    department: "SoBT",
    roll: "23ibo035",
    email: "23ibo035@smvdu.ac.in",
    category: "PR Team",
    avatar_url: "/assests/Team%20Images/Prayu%20Suman%2023ibo035.jpg",
    linkedin: null,
  },
  {
    id: "pr-4",
    name: "Parag Kumar",
    role: "Co-Lead",
    department: "SoCSE",
    roll: "23bcs060",
    email: "23bcs060@smvdu.ac.in",
    category: "PR Team",
    avatar_url: "/assests/Team%20Images/Parag%20Kumar%2023bcs060.jpg",
    linkedin: null,
  },

  // ─────────────────────────────────────────────────────────────
  // SPONSORSHIP TEAM
  // ─────────────────────────────────────────────────────────────
  {
    id: "sponsor-1",
    name: "Sachin Tripathi",
    role: "Coordinator",
    department: "SoCSE",
    roll: "23bcs079",
    email: "23bcs079@smvdu.ac.in",
    category: "Sponsorship Team",
    avatar_url: "/assests/Team%20Images/Sachin%20Tripathi%2023bcs079.jpeg",
    linkedin: null,
  },
  {
    id: "sponsor-2",
    name: "Achalendra Pratap Singh",
    role: "Coordinator",
    department: "SoCSE",
    roll: "22bcs005",
    email: "22bcs005@smvdu.ac.in",
    category: "Sponsorship Team",
    avatar_url: "/assests/Team%20Images/Achalendra%20Pratap%20Singh%2022bcs005.jpg",
    linkedin: null,
  },

  // ─────────────────────────────────────────────────────────────
  // DECORATION TEAM
  // ─────────────────────────────────────────────────────────────
  {
    id: "deco-1",
    name: "Parasu P S Venkata Pravallika",
    role: "Coordinator",
    department: "SoBT",
    roll: "22ibo022",
    email: "22ibo022@smvdu.ac.in",
    category: "Decoration Team",
    avatar_url: "/assests/Team%20Images/Parasu%20P%20S%20Venkata%20Pravallika%2022ibo022.webp",
    linkedin: null,
  },
  {
    id: "deco-2",
    name: "Anushka Tickoo",
    role: "Coordinator",
    department: "SoME",
    roll: "23bme006",
    email: "23bme006@smvdu.ac.in",
    category: "Decoration Team",
    avatar_url:"/assests/Team%20Images/Anushka%20Tickoo%2023bme006.jpeg",
    linkedin: null,
  },
  // ─────────────────────────────────────────────────────────────
  // SCHOOL COORDINATORS  — updated from Excel form responses
  // ─────────────────────────────────────────────────────────────
  {
    id: "sc-1",
    name: "Akash Kumar Chaurasiya",
    role: "Coordinator",
    department: "SoCSE",
    roll: "23bcs010",
    email: "23bcs010@smvdu.ac.in",
    category: "School Coordinators",
    avatar_url: "/assests/Team%20Images/Akash%20Kumar%20Chaurasiya%2023bcs010.JPG",
    linkedin: null,
  },
  {
    id: "sc-2",
    name: "Kartikey Saxena",
    role: "Coordinator",
    department: "SoCSE",
    roll: "23bcs039",
    email: "23bcs039@smvdu.ac.in",
    category: "School Coordinators",
    avatar_url: "/assests/Team%20Images/Kartikey%20Saxena%2023bcs039.jpg",
    linkedin: null,
  },
  {
    id: "sc-3",
    name: "Shrikant Jha",
    role: "Coordinator",
    department: "SoECE",
    roll: "23bec054",
    email: "23bec054@smvdu.ac.in",
    category: "School Coordinators",
    avatar_url: "/assests/Team%20Images/Shrikant%20Jha%2023bec054.jpg",
    linkedin: null,
  },
  {
    id: "sc-4",
    name: "Durgesh Kumar",
    role: "Coordinator",
    department: "SoCE",
    roll: "23bce011",
    email: "23bce011@smvdu.ac.in",
    category: "School Coordinators",
    avatar_url: "/assests/Team%20Images/Durgesh%20Kumar%2023bce011.jpeg",
    linkedin: null,
  },
  {
    id: "sc-5",
    name: "Gursimran Singh",
    role: "Coordinator",
    department: "SoME",
    roll: "23bme012",
    email: "23bme012@smvdu.ac.in",
    category: "School Coordinators",
    avatar_url: "/assests/Team%20Images/Gursimran%20Singh%2023bme012.jpeg",
    linkedin: null,
  },
  {
    id: "sc-6",
    name: "Aashish Rathour",
    role: "Coordinator",
    department: "SoEE",
    roll: "23bee001",
    email: "23bee001@smvdu.ac.in",
    category: "School Coordinators",
    avatar_url: "/assests/Team%20Images/Aashish%20Rathour%2023bee001.jpg",
    linkedin: null,
  },
  {
    id: "sc-7",
    name: "Abhilasha Singh",
    role: "Coordinator",
    department: "SoALD",
    roll: "23bar003",
    email: "23bar003@smvdu.ac.in",
    category: "School Coordinators",
    avatar_url: "/assests/Team%20Images/Abhilasha%20Singh%2023bar003.jpg",
    linkedin: null,
  },
  {
    id: "sc-8",
    name: "Antriksha Rathore",
    role: "Coordinator",
    department: "SoBT",
    roll: "22ibo043",
    email: "22ibo043@smvdu.ac.in",
    category: "School Coordinators",
    avatar_url: "/assests/Team%20Images/ANTRIKSHA%20RATHORE%2022IBO043.jpeg",
    linkedin: null,
  },
  {
    id: "sc-9",
    name: "Shruti Manhas",
    role: "Coordinator",
    department: "SoP",
    roll: "21iby023",
    email: "21iby023@smvdu.ac.in",
    category: "School Coordinators",
    avatar_url: "/assests/Team%20Images/Shruti%20Manhas%2021iby023.jpg",
    linkedin: null,
  },
  {
    id: "sc-10",
    name: "Hiteshi Taggar",
    role: "Coordinator",
    department: "SoLL",
    roll: "25dln002",
    email: "25dln002@smvdu.ac.in",
    category: "School Coordinators",
    avatar_url: "/assests/Team%20Images/Hiteshi%20Taggar%2025dln002.jpg",
    linkedin: null,
  },
{
    id: "sc-11",
    name: "Variga Khajuria",
    role: "Coordinator",
    department: "SoLL",
    roll: "21ibe035",
    email: "21ibe035@smvdu.ac.in",
    category: "School Coordinators",
    avatar_url: "/assests/Team%20Images/Variga%20Khajuria%2021ibe035.jpeg",
    linkedin: null,
  },
  {
    id: "sc-12",
    name: "Abhishai Prakash",
    role: "Coordinator",
    department: "SoM",
    roll: "24bcm002",
    email: "24bcm002@smvdu.ac.in",
    category: "School Coordinators",
    avatar_url: "/assests/Team%20Images/ABHISHAI%20PRAKASH%2024bcm002.jpeg",
    linkedin: null,
  },
];

// Helper: get members by category
export const getTeamByCategory = (category) =>
  TEAM_DATA.filter((m) => m.category === category);

// All unique categories in order
export const TEAM_CATEGORIES = [
  "Core Team",
  "Website Team",
  "Technical Team",
  "Design Team",
  "PR Team",
  "Sponsorship Team",
  "Decoration Team",
  "School Coordinators",
];
